const childrenLoaded = require('@alexspirgel/children-loaded');
class BlockText extends HTMLElement {
  constructor() {
    super();
  }

  async connectedCallback() {
    await childrenLoaded(this);
    const iframes = this.querySelectorAll('iframe');
    const blockQuotes = this.querySelectorAll('blockquote');
    iframes.forEach((iframe) => {
      if (iframe.parentNode && iframe.parentNode.classList.contains('iframe-wrapper')) {
        return;
      }
      const wrapper = document.createElement('div');
      wrapper.classList.add('iframe-wrapper');
      iframe.parentNode.insertBefore(wrapper, iframe);
      wrapper.appendChild(iframe);
    });
    blockQuotes.forEach((blockQuote) => {
      if (blockQuote.parentNode && blockQuote.parentNode.classList.contains('blockquote-wrapper')) {
        return;
      }
      const wrapper = document.createElement('div');
      wrapper.classList.add('blockquote-wrapper');

      blockQuote.parentNode.insertBefore(wrapper, blockQuote);
      wrapper.appendChild(blockQuote);
    });
  }
}
customElements.define('block-text', BlockText, { extends: 'section' });

// document.querySelector(".resource-detail-info").style.display = "none";
// document.querySelector(".resource-detail-info__pager").style.display = "none";
// document.querySelector(".issue-footer__form-container").style.display = "none";
// document.querySelector(".kaleidoscope-hero").style.display = "none";
// document.querySelector(".footer").style.display = "none";
// document.getElementById('header-main').style.display = "none";
// document.querySelector(".resource-detail-info__authors").style.display = "none";
//
// document.querySelectorAll('.issue-footer__grid--pdf-data').forEach((element) => {
//   element.style.display = 'grid';
// });
//
// document.querySelectorAll('.block-accordion__item').forEach((element) => {
//   if (element.getAttribute('aria-expanded') === 'false') {
//     element.click();
//   }
// });